"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const dateOptionsShort = {
  year: 'numeric',
  month: 'short',
  day: 'numeric'
};
const dateOptionsLong = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
const hoursOptions = {
  hour: 'numeric',
  minute: 'numeric',
  hour12: true
};
const defaultOptions = {
  language: 'es-CL',
  withHours: false,
  longFormat: false
};

/**
 * Formats a date into a localized string based on the provided options.
 *
 * @param {Date | string} date - The date to format. Accepts a `Date` object or a string that can be parsed into a `Date`.
 * @param {Partial<DateFormatOptions>} [options=defaultOptions] - Custom configuration for formatting the date.
 * @param {string} [options.language='es-CL'] - The language locale to use (default is 'es-CL').
 * @param {boolean} [options.longFormat=false] - Whether to use a long format for the date.
 * @param {boolean} [options.withHours=false] - Whether to include the time in the formatted string.
 * @returns {string} - The formatted date string, optionally including time.
 *
 * @example
 * // Basic usage
 * const formattedDate = dateFormat(new Date(), { language: 'es-CL', longFormat: true })
 * console.log(formattedDate) // "25 de diciembre de 2024"
 *
 * @example
 * // Include time
 * const formattedDateWithTime = dateFormat(new Date(), { withHours: true })
 * console.log(formattedDateWithTime) // "Dec 25, 2024 11:59 PM"
 */
function dateFormat(date) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  const standardizedDate = new Date(date || new Date());
  const {
    language,
    withHours,
    longFormat
  } = _objectSpread(_objectSpread({}, defaultOptions), options);
  const dateOptions = longFormat ? dateOptionsLong : dateOptionsShort;
  const formattedDate = standardizedDate.toLocaleDateString(language, dateOptions);
  const formattedHours = standardizedDate.toLocaleString('en-US', hoursOptions);
  return "".concat(formattedDate, " ").concat(withHours ? "".concat(formattedHours) : '');
}
var _default = exports.default = dateFormat;